module.exports = __webpack_public_path__ + "static/media/elite-mobile-small-blob.9246f199.svg";